module.exports = {"TXTWCL_Set_gaming_limits":{"id":"TXTWCL_Set_gaming_limits","defaultMessage":"Встановіть ігрові ліміти"}}